import { Link } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Flex,
  Switch,
  BoxProps,
  Checkbox,
} from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';

export interface PrivacyGroupItem {
  id: string;
  title: string;
  description?: string;
  enabled: boolean;
}

export interface PrivacyGroupProps extends BoxProps {
  title?: string;
  description: string;
  learnMoreLink: string;
  master: PrivacyGroupItem;
  items: PrivacyGroupItem[];
  handleToggle: (master: PrivacyGroupItem, item?: PrivacyGroupItem) => void;
}

export const PrivacyGroup = ({
  title,
  description,
  learnMoreLink,
  master,
  items,
  handleToggle,
  ...rest
}: PrivacyGroupProps) => {
  return (
    <Box width="full" {...rest}>
      {title && (
        <Heading as="h3" size="sm" fontWeight="500" color="M.70">
          {title}
        </Heading>
      )}
      <Text pt={1} pb={4} color="M.60" fontSize="xs" whiteSpace="pre-line">
        {description}&nbsp;
        <Text
          color="M.60"
          fontSize="xs"
          as={Link}
          to={learnMoreLink}
          target="_blank"
        >
          Learn more
        </Text>
      </Text>
      <Flex
        alignItems="center"
        justify="space-between"
        bg={(transparentize('M.30', 0.36) as unknown) as string}
        py={3}
        px={1}
        rounded="md"
      >
        <Box>
          <Text>{master.title}</Text>
          {master.description && (
            <Text color="M.60" fontSize="xs">
              {master.description}
            </Text>
          )}
        </Box>
        <Switch
          ml={2}
          isChecked={master.enabled}
          onChange={() => handleToggle(master)}
        />
      </Flex>
      {master.enabled &&
        items.map((item) => (
          <Flex
            key={item.id}
            alignItems="center"
            justify="space-between"
            pl={1}
          >
            <Box>
              <Text fontWeight="400">{item.title}</Text>
              {description && (
                <Text color="M.60" fontSize="xs">
                  {item.description}
                </Text>
              )}
            </Box>
            <Checkbox
              ml={2}
              isChecked={item.enabled}
              onChange={() => {
                handleToggle(master, item);
              }}
            />
          </Flex>
        ))}
    </Box>
  );
};
